import { render, staticRenderFns } from "./Questionpaper.vue?vue&type=template&id=1eb6eaa1&scoped=true"
import script from "./Questionpaper.vue?vue&type=script&lang=js"
export * from "./Questionpaper.vue?vue&type=script&lang=js"
import style0 from "./Questionpaper.vue?vue&type=style&index=0&id=1eb6eaa1&prod&lang=less"
import style1 from "./Questionpaper.vue?vue&type=style&index=1&id=1eb6eaa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb6eaa1",
  null
  
)

export default component.exports